import {
  GET_CART_DETAILS_PENDING,
  GET_CART_DETAILS_FULFILLED,
  GET_CART_DETAILS_FAILED,
  SET_CART_DETAILS_PENDING,
  SET_CART_DETAILS_FULFILLED,
  SET_CART_DETAILS_FAILED,
  RESET_CART_DETAILS,
  RESET_CART_STATUS,
  RESET_USER_ACCOUNT,
} from "constants-lib/actionTypes"

const initialState = {
  getCartDetailsStatus: ``,
  setCartDetailsStatus: ``,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CART_DETAILS_PENDING: {
      return {
        ...state,
        getCartDetailsStatus: `pending`,
      }
    }

    case GET_CART_DETAILS_FULFILLED: {
      if (!action.payload.url) {
        // eslint-disable-next-line no-param-reassign
        action.payload.url = ``
      }
      return {
        ...state,
        ...action.payload.cart,
        getCartDetailsStatus: `fulfilled`,
      }
    }

    case RESET_USER_ACCOUNT: {
      if (action.payload?.resetCart) {
        return {
          ...initialState,
        }
      }

      return {
        ...state,
      }
    }

    case GET_CART_DETAILS_FAILED: {
      return {
        ...initialState,
        getCartDetailsStatus: `failed`,
      }
    }

    case SET_CART_DETAILS_PENDING: {
      return {
        ...state,
        setCartDetailsStatus: `pending`,
      }
    }

    case SET_CART_DETAILS_FULFILLED: {
      if (!action.payload.url) {
        // eslint-disable-next-line no-param-reassign
        action.payload.url = ``
      }
      return {
        ...state,
        ...action.payload,
        setCartDetailsStatus: `fulfilled`,
      }
    }

    case SET_CART_DETAILS_FAILED: {
      return {
        ...initialState,
        setCartDetailsStatus: `failed`,
      }
    }

    case RESET_CART_DETAILS: {
      return {
        ...state,
        setCartDetailsStatus: ``,
        getCartDetailsStatus: ``,
        id: ``,
        count: ``,
        url: ``,
      }
    }

    case RESET_CART_STATUS: {
      return {
        ...state,
        setCartDetailsStatus: ``,
      }
    }

    default:
      return state
  }
}
